<!-- 搜索页面 -->
<template>
  <div class="search">
    <Top></Top>
    <div class="search-wrap acea-row row-center-wrapper">
      <div class="search-input-wrap acea-row row-middle">
        <el-input
          class="search-input"
          placeholder=""
          v-model="kwd"
          @keyup.enter="search"
        />
        <div class="search-select-wrap acea-row row-center-wrapper">
          <div @click.stop="searchSelectShow = true">
            {{ searchType === 1 ? "全站图片" : "目的地" }}
          </div>
          <div
            class="select-menu"
            :class="searchSelectShow ? 'select-menu-show' : ''"
          >
            <div
              @click.stop="
                searchType = 1;
                searchSelectShow = false;
                search();
              "
              :class="searchType === 1 ? 'active' : ''"
              class="select-menu-item acea-row row-center-wrapper"
            >
              全站图片
            </div>
            <div
              @click.stop="
                searchType = 2;
                searchSelectShow = false;
                search();
              "
              :class="searchType === 2 ? 'active' : ''"
              class="select-menu-item acea-row row-center-wrapper"
            >
              目的地
            </div>
            <div
              @click.stop="
                searchType = 3;
                searchSelectShow = false;
                search();
              "
              :class="searchType === 3 ? 'active' : ''"
              class="select-menu-item acea-row row-center-wrapper"
            >
              摄影师
            </div>
          </div>
        </div>
      </div>
      <div
        class="search-btn acea-row row-center-wrapper"
        @click="search()"
      >
        <img src="../imgs/akar-icons_search.png" />
        <span>搜索</span>
      </div>
    </div>

    <div class="type-list-wrap acea-row row-middle">
      <div>类别：</div>
      <div
        @click="
          typeIndex = index;
          search();
        "
        class="type-item"
        :class="typeIndex === index ? 'active' : ''"
        v-for="(item, index) in typeList"
        :key="index"
      >
        {{ item }}
      </div>
      <!-- <div
        @click="
          typeIndex = index;
          search();
        "
        class="type-item"
        :class="typeIndex === index ? 'active' : ''"
        v-for="(item, index) in typeList" :key="index"
      >
        {{ item }}
      </div> -->
    </div>
    <div
      class="acea-row row-middle"
      style="padding-left: 44px; height: 78px; color: #5c5c5c"
    >
      共有<span style="color: #f00">&nbsp;{{ total }}&nbsp;</span>条结果
    </div>
    <Upgrade :dataArr='dataArr'> </Upgrade>
    <Pagination
      class="block"
      :total="total"
      @pageChange="pageChange"
    > </Pagination>

  </div>
</template>

<script>
import Top from "../components/top";
import Upgrade from "../components/upgrade";
import Pagination from "../components/pagination";
import img_url from "../assets/logo.png";
export default {
  name: "search",
  data () {
    return {
      kwd: "",
      typeList: [
        "全部",
        "美景",
        "民宿",
        "活动",
        "会议",
        "特产",
        "人物",
        "动植物",
        "其他",
      ],
      total: 123,
      typeIndex: 0,
      page: 1,
      searchSelectShow: false,
      actindex: 1,
      searchType: 1,
      dataArr: [
        // {
        //   id: 1,
        //   name: "头像",
        //   description: "最近的头像委托|插画|商业插画",
        //   src: "http://hbimg.huabanimg.com/d8cc2a52fe3b31ac24728d868a2aeb736fffbd6e6908f-0WKnt2_/fw/480",
        //   user_name: "Mcdoll",
        //   user_url: img_url,
        //   date: "2020-02-10",
        //   href: "",
        //   type: "插画",
        //   hot: 100,
        // },
        // {
        //   name: "列车",
        //   description: "《再次起飞》系列插画重新修改总结|插画|商业插画",
        //   src: "http://hbimg.huabanimg.com/8bf2f5a9b6d7e1558eec150f7b9a98feaff105de1e9487-lgyMGO_/fw/480",
        //   user_name: "布克舒先生",
        //   date: "2020-02-10",
        //   href: "https://huaban.com/pins/2961177875/",
        //   type: "插画",
        // },
        // {
        //   name: "列车",
        //   description: "最近的头像委托|插画|商业插画",
        //   src: "http://hbimg.huabanimg.com/d8cc2a52fe3b31ac24728d868a2aeb736fffbd6e6908f-0WKnt2_/fw/480",
        //   user_name: "Mcdoll",
        //   date: "2020-02-10",
        //   href: "https://huaban.com/pins/2961177875/",
        //   type: "插画",
        // },
        // {
        //   name: "列车",
        //   description: "《再次起飞》系列插画重新修改总结|插画|商业插画",
        //   src: "http://hbimg.huabanimg.com/8bf2f5a9b6d7e1558eec150f7b9a98feaff105de1e9487-lgyMGO_/fw/480",
        //   user_name: "布克舒先生",
        //   date: "2020-02-10",
        //   href: "https://huaban.com/pins/2961177875/",
        //   type: "插画",
        // },
        // {
        //   name: "列车",
        //   description: "《再次起飞》系列插画重新修改总结|插画|商业插画",
        //   src: "http://hbimg.huabanimg.com/8bf2f5a9b6d7e1558eec150f7b9a98feaff105de1e9487-lgyMGO_/fw/480",
        //   user_name: "布克舒先生",
        //   date: "2020-02-10",
        //   href: "https://huaban.com/pins/2961177875/",
        //   type: "插画",
        // },
        // {
        //   name: "列车",
        //   description: "《再次起飞》系列插画重新修改总结|插画|商业插画",
        //   src: "http://hbimg.huabanimg.com/8bf2f5a9b6d7e1558eec150f7b9a98feaff105de1e9487-lgyMGO_/fw/480",
        //   user_name: "布克舒先生",
        //   date: "2020-02-10",
        //   href: "https://huaban.com/pins/2961177875/",
        //   type: "插画",
        // },
      ],
    };
  },
  methods: {
    jumpTo (event, { index, value }) {
      // 阻止a跳转
      event.preventDefault();
      let routeUrl = this.$router.resolve({
        path: "/detail",
        query: { id: value.id },
      });
      console.log(routeUrl.href);
      window.open(routeUrl.href, "_blank");
    },
    getData () { },
    search () { },
    pageChange () { },
  },
  created () {
    console.log("this is search");
    var url = "/" + this.$route.query.type + "/" + this.$route.query.name;
    // this.$axios
    //   .post(url, {
    //     name: this.$route.query.name,
    //   })
    //   .then((res) => {
    //     console.log(res);
    //     this.dataArr = res.result.list;
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // this.actindex = typeid;

    this.$axios
      .post("/work/list", {
        type: 1,
        order: 0,
        limit: 30,
        page: this.page,
      })
      .then((res) => {
        console.log(res);
        this.dataArr = res.result.list;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  components: {
    Top,
    Upgrade,
    Pagination,
  },
};
</script>

<style lang="scss" scoped>
.search /deep/ .top {
  min-width: 100%;
}
.search /deep/ .com {
  width: 100%;
}
.main {
  //width: 1200px;
  margin: 20px auto;
  height: 1000px;
}
.acea-row {
  display: flex;
  flex-wrap: wrap;
}
.acea-row.row-center-wrapper {
  align-items: center;
  justify-content: center;
}
.search-wrap {
  margin: 0 auto;
  min-width: 1200px;
  height: 140px;
  background-color: #ffffff;
  padding: 0 44px;
}

.search-input-wrap {
  flex: 1;
  height: 60px;
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
}

.search-btn {
  width: 190px;
  height: 60px;
  background: #dc3b3b;
  border-radius: 0px 3px 3px 0px;
  font-size: 24px;
  color: #ffffff;
  cursor: pointer;
}

.search-btn > img {
  width: 19px;
  height: 19px;
  margin-right: 15px;
}

.search-input {
  background-color: transparent;
  border: none;
  outline: none;
  flex: 1;
  height: 90%;
  padding-left: 30px;
}

.search-select-wrap {
  width: 172px;
  height: 100%;
  font-size: 18px;
  color: #999999;
  position: relative;
  cursor: pointer;
}

.search-select-wrap::before {
  content: "";
  height: 32px;
  border-left: 1px solid #999999;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -16px;
}

.search-select-wrap::after {
  content: "";
  width: 13px;
  height: 13px;
  // background: url(/imgs/akar-icons_search.png) no-repeat center / contain;
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -6.5px;
}

.select-menu {
  position: absolute;
  width: 172px;
  height: 0;
  /* background-color: #f00; */
  bottom: 0;
  transform: translate(0, 100%);
  overflow: hidden;
  /* transition: all 0.3s; */
  opacity: 0;
}

.select-menu.select-menu-show {
  height: 154px;
  opacity: 1;
}

.select-menu-item {
  width: 172px;
  height: 76px;
  font-size: 18px;

  background: #faf9f9;
  color: #999999;
}

.select-menu-item.active {
  background: #db3a3b;
  color: #ffffff;
}
.type-list-wrap {
  min-width: 1200px;
  height: 58px;
  border-top: 1px solid #e5e5e5;
  border-bottom: 1px solid #e5e5e5;
  padding-left: 44px;
  font-size: 14px;
  color: #5c5c5c;
}

.type-item {
  margin-right: 20px;
  cursor: pointer;
}

.type-item.active {
  color: #f00;
}
.block {
  display: inline-block;
  width: 100%;
  align-items: center;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue